import { Avatar, Box, Chip, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { appIcons, appImages } from "../../../../assets";
import { useNavigate } from "react-router-dom";

const ChatList = () => {
  const naviagte = useNavigate();

  return (
    <Box
      height={"100%"}
      bgcolor={"text.white"}
      borderRadius={2}
      boxShadow={" 0px 2px 12px 0px #25334226"}
    >
      <Stack p={2} direction={"row"} alignItems={"center"} spacing={1}>
        <img
          src={appIcons.purpleBackArrowIcon}
          width={30}
          style={{
            cursor: "pointer",
          }}
          onClick={() => naviagte("/dashboard/education")}
        />
        <Typography variant="h6">Message</Typography>
        <Chip
          label={12}
          sx={{
            padding: "0px 12px",
            fontWeight: 500,
            backgroundColor: "#EDF2F7",
            "& .MuiChip-label": {
              padding: 0,
            },
          }}
        />
      </Stack>
      <Divider />
      <Stack
        p={2}
        height={76}
        bgcolor={"primary.main"}
        direction={"row"}
        alignItems={"center"}
        spacing={2}
        borderRadius={2}
        m={1}
        sx={{
          cursor: "pointer",
        }}
      >
        <Avatar
          src={appImages.serviceCleaningImg}
          sx={{
            borderRadius: 2,
            height: 45,
            width: 45,
          }}
        />
        <Box flexGrow={1}>
          <Typography
            variant="body1"
            fontWeight={500}
            color={"text.white"}
            noWrap
          >
            ABCD school Management
          </Typography>
          <Typography variant="body2" color={"text.white"} noWrap>
            Customer Support 🔥
          </Typography>
        </Box>
        <Typography
          variant={"body2"}
          alignSelf={"flex-start"}
          color={"text.white"}
        >
          12m
        </Typography>
      </Stack>
    </Box>
  );
};

export default ChatList;
